console.log("cart-recommendations-logic.js loaded and executing.");

// Configuration
const FREE_SHIPPING_THRESHOLD = 75; // Set your free shipping threshold here

// Selectors
const cartItemsContainer = document.querySelector('m-cart-drawer-items');
const progressBarContainer = document.getElementById('cart-progress-bar-container');
const progressBarFill = document.getElementById('progress-bar-fill');
const progressBarText = document.getElementById('cart-progress-text');
const recommendationsContainer = document.getElementById('cart-recommendations-splide'); // This is your Splide main container ID

// Helper function to fetch full cart data from Shopify's /cart.js endpoint
// This function will now only be called if cart data isn't provided by the event.
async function fetchCartData() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const cart = await response.json();
        return cart;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        return null; // Return null if fetching fails
    }
}

// Function to initialize Splide (if not already initialized) or refresh it
function initializeSplide() {
    const splideElement = document.querySelector('#cart-recommendations-splide');
    if (splideElement) {
        if (splideElement.splide) {
            console.log('Splide carousel already initialized. Refreshing.');
            splideElement.splide.refresh();
        } else if (typeof Splide !== 'undefined') { // Check only for the core Splide library
            console.log('Initializing Splide carousel for recommendations.');
            new Splide(splideElement, {
                type: 'loop',
                perPage: 1, // Set to 1 as per your request, for all screen sizes
                gap: '15px',
                pauseOnHover: true,
                arrows: true, // <-- SET TO TRUE as requested
                pagination: false,
                padding: {right: '20%'},
            }).mount(); // No extension passed to mount
        } else {
            console.warn("Splide library not loaded. Cannot initialize Splide.");
        }
    } else {
        console.log("Splide element (#cart-recommendations-splide) not found for initialization.");
    }
}


// updateProgressBar function (now accepts optional cartData)
async function updateProgressBar(cartData = null) {
    console.log('UPDATE_PROGRESS_BAR: Function started.');
    let cart = cartData; // Use provided cartData if available
    if (!cart) { // If not provided, fetch it (this will be the fallback)
        console.log('UPDATE_PROGRESS_BAR: No cart data provided, fetching...');
        cart = await fetchCartData();
    }
    console.log('UPDATE_PROGRESS_BAR: Cart data ready.');

    if (!cart) {
        console.error("Failed to get cart data for progress bar update. Aborting.");
        if (progressBarContainer) {
            console.log('UPDATE_PROGRESS_BAR: Hiding progress bar due to failed cart fetch.');
            progressBarContainer.style.display = 'none';
        }
        return;
    }

    const cartTotal = cart.total_price / 100;
    const cartItemCount = cart.item_count;

    if (!progressBarContainer || !progressBarFill || !progressBarText) {
        console.warn("Progress bar elements not found during updateProgressBar execution:", { progressBarContainer, progressBarFill, progressBarText });
        return;
    }

    if (cartItemCount === 0) {
        console.log('UPDATE_PROGRESS_BAR: Hiding progress bar (cart empty).');
        progressBarContainer.style.display = 'none';
        return;
    }

    console.log('UPDATE_PROGRESS_BAR: Showing progress bar.');
    progressBarContainer.style.display = 'block';

    const currencyFormatter = new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
        progressBarFill.style.width = '100%';
        progressBarText.textContent = 'Congrats! You’ve unlocked FREE Shipping. 🎉';
        progressBarContainer.style.backgroundColor = '#d4edda';
        progressBarText.style.color = '#155724';
        console.log('UPDATE_PROGRESS_BAR: Progress bar set to FREE Shipping state.');
    } else {
        const progress = (cartTotal / FREE_SHIPPING_THRESHOLD) * 100;
        progressBarFill.style.width = `${Math.min(progress, 100)}%`;

        const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
        const formattedRemaining = currencyFormatter.format(remaining);

        progressBarText.textContent = `You're ${formattedRemaining} away from FREE Shipping!`;
        progressBarContainer.style.backgroundColor = '#e9ecef';
        progressBarText.style.color = '#343a40';
        console.log('UPDATE_PROGRESS_BAR: Progress bar set to progress state.');
    }
}

// updateRecommendations function (now accepts optional cartData)
async function updateRecommendations(cartData = null) {
    console.log('UPDATE_RECOMMENDATIONS: Function started.');
    let cart = cartData; // Use provided cartData if available
    if (!cart) { // If not provided, fetch it (this will be the fallback)
        console.log('UPDATE_RECOMMENDATIONS: No cart data provided, fetching...');
        cart = await fetchCartData();
    }
    console.log('UPDATE_RECOMMENDATIONS: Cart data ready.');

    if (!cart) {
        console.error("Failed to get cart data for recommendations update. Aborting.");
        if (recommendationsContainer) {
            console.log('UPDATE_RECOMMENDATIONS: Hiding recommendations due to failed cart fetch.');
            recommendationsContainer.style.display = 'none';
        }
        return;
    }

    const cartItemCount = cart.item_count;

    if (!recommendationsContainer) {
        console.warn("Recommended products container (#cart-recommendations-splide) not found during updateRecommendations execution.");
        return;
    }

    if (cartItemCount > 0) {
        console.log('UPDATE_RECOMMENDATIONS: Showing recommendations (cart not empty).');
        recommendationsContainer.style.display = 'block';

        // --- NEW LOGIC TO RE-FETCH AND RE-RENDER RECOMMENDATIONS ---
        try {
            console.log('UPDATE_RECOMMENDATIONS: Fetching new recommendations section HTML.');
            const sectionName = 'cart-drawer'; 

            const response = await fetch(`/?sections=${sectionName}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const sections = await response.json();
            const fullSectionHtml = sections[sectionName];
            console.log('UPDATE_RECOMMENDATIONS: New recommendations section HTML fetched.');


            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = fullSectionHtml;

            const newSplideElement = tempDiv.querySelector('#cart-recommendations-splide');

            if (newSplideElement) {
                // If there's an existing Splide instance, destroy it before replacing HTML
                if (recommendationsContainer.splide) {
                    console.log('UPDATE_RECOMMENDATIONS: Destroying existing Splide instance.');
                    recommendationsContainer.splide.destroy();
                    recommendationsContainer.splide = null; // Clear the reference
                }

                console.log('UPDATE_RECOMMENDATIONS: Replacing recommendations HTML content.');
                recommendationsContainer.innerHTML = newSplideElement.innerHTML;
                console.log('UPDATE_RECOMMENDATIONS: Recommendations HTML updated. Re-initializing Splide.');
                initializeSplide(); // Re-initialize Splide on the new HTML
            } else {
                console.warn(`'#cart-recommendations-splide' not found within the re-fetched '${sectionName}' section. Please check your section structure and ID.`);
            }

        } catch (error) {
            console.error('Error re-fetching or re-rendering recommendations section:', error);
        }
        // --- END NEW LOGIC ---

    } else {
        console.log('UPDATE_RECOMMENDATIONS: Hiding recommendations (cart empty).');
        recommendationsContainer.style.display = 'none';
        if (recommendationsContainer.splide) {
            recommendationsContainer.splide.pause();
            console.log('Splide carousel paused due to empty cart.');
        }
    }
    console.log('UPDATE_RECOMMENDATIONS: Function finished.');
}


// Initialize state when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', async () => {
    console.log("DOM_LOADED: DOMContentLoaded fired. Initializing cart state.");
    console.log("DOM_LOADED: Initial load: updating cart state.");
    // For initial load, functions will fetch cart data internally
    await updateProgressBar();
    await updateRecommendations();
    console.log("DOM_LOADED: Initial cart state update completed.");
});

// Set up MutationObserver to watch for cart changes
const observerConfig = { childList: true, subtree: true, attributes: true, characterData: true };
const observerTarget = cartItemsContainer;

if (observerTarget) {
    const observer = new MutationObserver((mutationsList, observer) => {
        console.log('OBSERVER: Cart DOM mutation detected. Applying debounce.');
        clearTimeout(window.cartUpdateTimeout);
        window.cartUpdateTimeout = setTimeout(async () => {
            console.log('OBSERVER: Debounce finished. Updating progress bar and recommendations.');
            // MutationObserver does not provide cart data directly, so functions will fetch if needed
            await updateProgressBar();
            await updateRecommendations();
            console.log('OBSERVER: Cart update completed via MutationObserver.');
        }, 50);
    });

    observer.observe(observerTarget, observerConfig);
    console.log('OBSERVER: MutationObserver set up to watch for changes in:', observerTarget);
} else {
    console.error('OBSERVER: Cart items container not found for MutationObserver setup.');
}

// Listen for custom events if your theme triggers them on cart updates
document.addEventListener('shopify:cart:updated', async (event) => {
    console.log('SHOPIFY_EVENT: shopify:cart:updated event detected. Applying debounce.');
    clearTimeout(window.cartUpdateTimeout);
    window.cartUpdateTimeout = setTimeout(async () => {
        console.log('SHOPIFY_EVENT: Debounce finished. Updating progress bar and recommendations.');
        const cartDataFromEvent = event.detail?.cart; // Use optional chaining for safer access
        if (cartDataFromEvent) {
            console.log('SHOPIFY_EVENT: Using cart data from event detail.');
        } else {
            console.log('SHOPIFY_EVENT: Cart data not in event detail. Functions will fetch as fallback.');
        }
        // Pass cart data from event to update functions to avoid re-fetching
        await updateProgressBar(cartDataFromEvent);
        await updateRecommendations(cartDataFromEvent);
        console.log('SHOPIFY_EVENT: Cart update completed via shopify:cart:updated event.');
    }, 50);
});